import React, { useContext, useState } from 'react';
import { Row, Col, Card, CardBody, Media } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import styles from './BuildPlan.module.css';
import { ReactComponent as RefrigeratorIcon } from '../../../assets/images/range-refrigerator.svg';
import { ReactComponent as LaundryIcon } from '../../../assets/images/washer-dryer.svg';
import { ReactComponent as RangeIcon } from '../../../assets/images/range.svg';
import { ReactComponent as BillsIcon } from '../../../assets/images/Vendor/NJR/bills.svg';
import { ReactComponent as Phone } from '../../../assets/images/Vendor/NJR/phone.svg';
import { ReactComponent as CalendarDateIcon } from '../../../assets/images/Vendor/NJR/calendar-date.svg';
import { ReactComponent as ToolsIcon } from '../../../assets/images/Vendor/NJR/tools.svg';
import { BrandingContext } from '../../contexts/ContractContext';
import getClientContent from '../../_BrandingProvider/brandContent';
import PlanOptionModal from '../../modals/PlanOptions/PlanOptions';
import classNames from 'classnames';
import DishwasherIcon from '../../../assets/images/Vendor/NJR/Dishwasher_repair.jpg';

const BuildPlan = () => {
    const branding = useContext(BrandingContext);
    const clientId = branding.contract || 'NJR';
    const [showPlanOptionModal, setShowPlanOptionModal] = useState(false);
    const { variableText } = getClientContent(clientId);
    const claimPhoneNumber = variableText.claim.phone;
    const isDesktop = useMediaQuery({ minWidth: '1024px' });

    const handlePlanOptionModal = (event) => {
        event.preventDefault();
        setShowPlanOptionModal(true);
    };

    const serviceSteps = [
        {
            icon: <Phone />,
            headingText: 'File a Claim',
            bodyText: (
                <p>
                    Simply call {claimPhoneNumber} and <br className='show-lg-up' /> pay your service fee.
                </p>
            )
        },
        {
            icon: <CalendarDateIcon />,
            headingText: 'Make an Appointment',
            bodyText: (
                <p>
                    Schedule service at your convenience <br className='show-lg-up' /> with local, authorized
                    technicians.
                </p>
            )
        },
        {
            icon: <ToolsIcon />,
            headingText: 'Quality Repair',
            bodyText: (
                <p>
                    The company you know and trust providing <br className='show-lg-up' /> reliable service you can
                    depend on.
                </p>
            )
        }
    ];

    const items = [
        {
            icon: <RefrigeratorIcon />,
            headingText: 'Kitchen Appliances',
            bodyText: 'Refrigerator, Dishwasher and more'
        },
        {
            icon: <LaundryIcon />,
            headingText: 'Laundry Appliances',
            bodyText: 'Washer and Dryer'
        },
        {
            icon: <RangeIcon style={{ height: '70px' }} />,
            headingText: 'Add-on Coverages',
            bodyText: 'Secondary Products Available'
        },
        {
            icon: <BillsIcon />,
            headingText: 'Payment Options',
            bodyText: 'Yearly or Monthly Pay'
        }
    ];

    const showItems = (item) => {
        return (
            <Col
                lg='3'
                md='6'
                sm='6'
                xs='6'
            >
                <Card className={styles.viewPlansCard}>
                    <CardBody className={styles.viewPlansCardBody}>
                        <span className={styles.viewPlansIcon}>{item.icon}</span>
                        <div className={styles.viewPlansCardTitle}>
                            <h2 className={classNames('h4', styles.cardHeading)}>{item.headingText}</h2>
                            <p>{item.bodyText}</p>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        );
    };

    const showServicesteps = (serviceStep) => {
        return (
            <Media className={`${styles.serviceStepsMedia} mb-3`}>
                <Media
                    left
                    className={styles.serviceIcon}
                >
                    {serviceStep.icon}
                </Media>
                <Media
                    body
                    className={styles.serviceContent}
                >
                    <Media
                        heading
                        className='mb-1'
                    >
                        {serviceStep.headingText}
                    </Media>
                    <p>{serviceStep.bodyText}</p>
                </Media>
            </Media>
        );
    };

    return (
        <>
            <div className={styles.viewServicePlansContainer}>
                <h2>Build a Plan Just Right for You.</h2>
                <p className='mb-4'>
                    You can cover all your appliances under one plan, regardless of their age. Choose the Total
                    Appliance Bundle and save!
                </p>
                <Row>{items.map(showItems)}</Row>
                <Row>
                    <Col className={`mt-4 ${styles.viewPlansButtonContainer}`}>
                        <button
                            className='btn btn-primary'
                            aria-label='click to open compare plan options modal'
                            onClick={handlePlanOptionModal}
                        >
                            View Plan Comparison
                        </button>
                    </Col>
                </Row>
            </div>
            <div className={styles.servicesContainer}>
                <Col className={`${styles.serviceStepsContainer}`}>
                    <h3 className={classNames('h2', styles.serviceHeading)}>Repairs Made Simple.</h3>
                    <div className={styles.bulletsContainer}>{serviceSteps.map(showServicesteps)}</div>
                </Col>
                {isDesktop && (
                    <Col className={`${styles.serviceImageContainer} col-md-6`}>
                        <img
                            width='100%'
                            src={DishwasherIcon}
                            role='presentation'
                        />
                    </Col>
                )}
            </div>
            {showPlanOptionModal && (
                <PlanOptionModal
                    isOpen={showPlanOptionModal}
                    centered={true}
                    toggle={() => setShowPlanOptionModal(!showPlanOptionModal)}
                    isHome={true}
                />
            )}
        </>
    );
};

export default BuildPlan;
